import { initOpenTelemetry } from './index';
import { initWebVitals } from './webVitals';

if (initOpenTelemetry()) {
  initWebVitals();
}
